import * as React from "react";

import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button
} from "reactstrap";

import i18n from "i18n";

export interface UploadFileProps {
    isOpen: boolean;
    onCancel: () => void;
    onUpload: (file: File) => void;
}
export interface UploadFileState {
    file: File | null
}

export default class UploadFileDialog extends React.Component<
    UploadFileProps,
    UploadFileState
    > {

    constructor(props: UploadFileProps) {
        super(props);
        this.state = {
            file: null
        };
    }

    private handleSubmit(event: any) {
        event.preventDefault();

        if (!this.state.file) {
            return;
        }

        this.props.onUpload(this.state.file);
    }

    private uploadFile(event: any) {
        this.setState({ file: event.target.files[0] });
    }

    render() {
        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalHeader>
                    {i18n.Release.UploadFileDialog.Title}
                </ModalHeader>
                <ModalBody>
                    <form onSubmit={(e) => this.handleSubmit(e)}>
                        <input
                            type="file"
                            name="file"
                            onChange={(e) => this.uploadFile(e)}
                        />
                        <Button
                            color="primary"
                            disabled={!this.state.file}
                        >{i18n.Release.UploadFileDialog.UploadButton}
                        </Button>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="default"
                        onClick={() => {
                            this.setState({ file: null });
                            this.props.onCancel();
                        }}
                    >
                        {i18n.Global.Edit.Cancel}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/release-management/upload-file.tsx